__turbopack_context__.v({
  "button": "_8NDh0a_button",
  "buttons": "_8NDh0a_buttons",
  "cartButton": "_8NDh0a_cartButton",
  "chevron": "_8NDh0a_chevron",
  "container": "_8NDh0a_container",
  "current": "_8NDh0a_current",
  "divider": "_8NDh0a_divider",
  "dropdown": "_8NDh0a_dropdown",
  "flags": "_8NDh0a_flags",
  "isAnimated": "_8NDh0a_isAnimated",
  "isOpen": "_8NDh0a_isOpen",
  "navItem": "_8NDh0a_navItem",
  "navLink": "_8NDh0a_navLink",
  "navLinkTitle": "_8NDh0a_navLinkTitle",
  "navigation": "_8NDh0a_navigation",
  "panel": "_8NDh0a_panel",
  "primaryButton": "_8NDh0a_primaryButton",
  "primaryButtonText": "_8NDh0a_primaryButtonText",
  "searchButton": "_8NDh0a_searchButton",
  "searchNavItem": "_8NDh0a_searchNavItem",
  "secondaryButton": "_8NDh0a_secondaryButton",
  "sublink": "_8NDh0a_sublink",
  "sublinkContainer": "_8NDh0a_sublinkContainer",
  "sublinkGroup": "_8NDh0a_sublinkGroup",
  "sublinkGroupTitle": "_8NDh0a_sublinkGroupTitle",
  "sublinks": "_8NDh0a_sublinks",
  "userIcon": "_8NDh0a_userIcon",
  "wrapper": "_8NDh0a_wrapper",
});
